import React, { useRef, useState, useEffect } from "react";
import Slider from "react-slick";
import axios from "axios";
import profileDefault from "../images/profile.gif";
// import housingExpert from "../images/Homepage/expert.png";
import siddhiExpert from "../images/Homepage/siddhiExpert.png";

const NewRecommendedSellers = () => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const sellerRef = useRef(null);
  const handlePrevClick = () => {
    if (sellerRef.current) {
      sellerRef.current.slickPrev();
    }
  };

  const handleNextClick = () => {
    if (sellerRef.current) {
      sellerRef.current.slickNext();
    }
  };
  const seller = {
    dots: false,
    infinite: false,
    speed: 1000,
    autoplay: true,
    pauseOnHover: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    // prevArrow: <PrevArrow />,
    // nextArrow: <NextArrow />,
    arrows: null,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  };

  const fetchSellerData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/recommendedSellers`
      );
      if (response.data.status === "success") {
        setList(response.data.data); // Set the property list
        //alert(JSON.stringify(response.data.data))
        setLoading(false);
      } else {
        setList([]);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setList([]);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchSellerData();
  }, []);
  return (
    <div>
      {list?.length > 0 && (
        <section className="seller-section sectiontopgap">
          <div className="container">
            <div className="sectiontitle">
              <div className="titleunderline" data-aos="fade-right">
                <svg
                  width="64"
                  height="3"
                  viewBox="0 0 64 3"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2 1.5H62"
                    stroke="#F68633"
                    stroke-width="3"
                    stroke-linecap="round"
                  />
                </svg>
              </div>
              <h1>Recommended Sellers</h1>
            </div>

            <div className="slider-controls">
              <button
                className="recommended-prev-arrow prev-btn"
                onClick={handlePrevClick}
              >
                ❮
              </button>
              {/* <button className="view-all-btn">View All</button> */}
              <button
                className="recommended-next-arrow next-btn"
                onClick={handleNextClick}
              >
                ❯
              </button>
            </div>

            <div className="content">
              <Slider ref={sellerRef} {...seller}>
                {list?.length > 0 &&
                  list?.map((project, index) => (
                    <div className="outer-seller">
                      <div className="sellerbox">
                        <div className="siddhi-seller-top">
                          <div className="siddhi-seller-pic">
                            {/* HS */}
                            {project.user_image ? (
                              <img
                                src={project?.user_image}
                                alt="DreamSakha"
                                className="img-fluid"
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.style.display = "none";
                                  e.target.nextSibling.style.display = "flex";
                                }}
                              />
                            ) : null}
                            <div
                              className="recommendedFirstLetterHome"
                              style={{
                                display: project.user_image ? "none" : "flex",
                              }}
                            >
                              {project?.user_name
                                ? project?.user_name
                                    .split(" ")
                                    .map((word) => word.charAt(0).toUpperCase())
                                    .join("")
                                : ""}
                            </div>
                          </div>
                          <div className="siddhi-sellerdata">
                            <h4>{project.user_name}</h4>
                            <div className="text-center mt-1 mb-1">
                              {Array(5)
                                .fill(0)
                                .map((_, i) => (
                                  <svg
                                    key={i}
                                    width="19"
                                    height="16"
                                    viewBox="0 0 16 17"
                                    fill="rgb(255, 213, 0)"
                                    xmlns="http://www.w3.org/2000/svg"
                                    stroke="rgb(255, 213, 0)"
                                  >
                                    <path
                                      d="M7.51338 3.43946C7.66772 3.09321 7.74492 2.92008 7.85238 2.86677C7.94572 2.82045 8.05532 2.82045 8.14865 2.86677C8.25612 2.92008 8.33332 3.09321 8.48765 3.43946L9.71698 6.19742C9.76265 6.29978 9.78545 6.35096 9.82078 6.39015C9.85198 6.42483 9.89018 6.45257 9.93278 6.47156C9.98098 6.49302 10.0367 6.49891 10.1482 6.51067L13.151 6.8276C13.528 6.86739 13.7165 6.88728 13.8004 6.97301C13.8733 7.04747 13.9072 7.15174 13.892 7.25483C13.8745 7.3735 13.7337 7.50036 13.4521 7.75416L11.209 9.77563C11.1258 9.85063 11.0841 9.88817 11.0578 9.93383C11.0345 9.9743 11.0199 10.0192 11.015 10.0656C11.0095 10.118 11.0211 10.1728 11.0443 10.2825L11.6709 13.2363C11.7495 13.6072 11.7889 13.7926 11.7333 13.8988C11.6849 13.9912 11.5963 14.0556 11.4935 14.073C11.3753 14.093 11.2111 13.9984 10.8827 13.809L8.26698 12.3003C8.16992 12.2443 8.12138 12.2164 8.06978 12.2054C8.02412 12.1957 7.97692 12.1957 7.93125 12.2054C7.87965 12.2164 7.83112 12.2443 7.73405 12.3003L5.1184 13.809C4.79001 13.9984 4.62582 14.093 4.50754 14.073C4.4048 14.0556 4.31611 13.9912 4.26782 13.8988C4.21222 13.7926 4.25155 13.6072 4.33021 13.2363L4.95672 10.2825C4.97997 10.1728 4.9916 10.118 4.98608 10.0656C4.98119 10.0192 4.96661 9.9743 4.94328 9.93383C4.91691 9.88817 4.87528 9.85063 4.79204 9.77563L2.54896 7.75416C2.26735 7.50036 2.12654 7.3735 2.10904 7.25483C2.09384 7.15174 2.12771 7.04747 2.2006 6.97301C2.28452 6.88728 2.47302 6.86739 2.85002 6.8276L5.85288 6.51067C5.96434 6.49891 6.02006 6.49302 6.06824 6.47156C6.11088 6.45257 6.14905 6.42483 6.18029 6.39015C6.21559 6.35096 6.2384 6.29978 6.28404 6.19742L7.51338 3.43946Z"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                ))}
                            </div>
                            <img
                              src={siddhiExpert}
                              alt="Siddhi Ananta"
                              className="img-fluid"
                              style={{ width: "200px", height: "30px" }}
                            />
                          </div>
                        </div>
                        <div className="siddhi-seller-bot">
                          <ul>
                            {project.user_bios?.map((bioDetail, index) => (
                              <li key={index}>
                                <svg
                                  width="12"
                                  height="12"
                                  viewBox="0 0 12 12"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g clipPath="url(#clip0_3438_238)">
                                    <path
                                      d="M10.6876 6.56264C10.3126 8.43764 8.89889 10.2029 6.91455 10.5976C4.93021 10.9923 2.91655 10.0693 1.92028 8.30835C0.923998 6.54747 1.16995 4.34604 2.53029 2.84843C3.89064 1.3508 6.18756 0.937644 8.06256 1.68764"
                                      stroke="#343434"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M4.3125 5.8125L6.1875 7.6875L10.6875 2.8125"
                                      stroke="#343434"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_3438_238">
                                      <rect
                                        width="12"
                                        height="12"
                                        fill="white"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>{" "}
                                {bioDetail}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  ))}
              </Slider>
            </div>
          </div>
        </section>
      )}
    </div>
  );
};

export default NewRecommendedSellers;
